import { render, staticRenderFns } from "./relate-replies.vue?vue&type=template&id=01c318c8&"
import script from "./relate-replies.vue?vue&type=script&lang=js&"
export * from "./relate-replies.vue?vue&type=script&lang=js&"
import style0 from "./relate-replies.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports